import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImagesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImagesSparkle"><Path d="M19.9992 20L13.9992 14L11.9992 16L7.99922 12L3.69922 16.3" stroke="currentColor" strokeLinecap="square"/><Path d="M12 3.5H3.5V20.5H20.5V12" stroke="currentColor"/><Path d="M18.4 2H17.6L16.6 4.6L14 5.6V6.4L16.6 7.4L17.6 10H18.4L19.4 7.4L22 6.4V5.6L19.4 4.6L18.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImagesSparkle;
